/**
 * Reads the profile id key out of the current report URL. Returns the fourth path segment
 * (/report/:studyFid/:profileId/...), the value the per-profile IndexedDB databases are named from.
 *
 * @returns The profile id key segment of the current URL path.
 */
// eslint-disable-next-line import/prefer-default-export
export const getProfileIdKey = () => window.location.pathname.split('/')[3];
